export default __webpack_public_path__ + "static/media/star-regular.aa2a094b.svg";